module.exports = __webpack_public_path__ + "static/media/268.b90c19fa.wav";